module.exports = __webpack_public_path__ + "static/Program-CRM-0ac94ebea5a454fccb35c8382fe99de0.jpeg";